// Display component for sent field in Correspondence res obj

import { Alert } from "@mui/material";

type EmailAlertMsgProps = { status: string; closeAlert: () => void };

export const EmailAlertMsg = ({ status, closeAlert }: EmailAlertMsgProps) => {
  return (
    <>
      {status === "success" ? (
        <Alert
          variant="outlined"
          severity="success"
          onClose={closeAlert}
          sx={{ mb: 2 }}
        >
          Success! Email has been sent.
        </Alert>
      ) : (
        <Alert
          variant="outlined"
          severity="error"
          onClose={closeAlert}
          sx={{ mb: 2 }}
        >
          Failed Attempt. Email has not been sent.
        </Alert>
      )}
    </>
  );
};
